var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-view',{attrs:{"title":"Auxiliar de Movimientos de Cuentas"}},[_c('div',{staticClass:"container-fluid mt-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('reporte-auxiliar-cuentas')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }